export default theme => ({
  shareListButton: {
    textTransform: 'none',
    backgroundColor: theme.palette.green.main,
  },
  shareListIcon: {
    marginRight: 5,
  },
});
